module.exports = __webpack_public_path__ + "img/A58A0997_min.d10081b6.jpg";